// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BreakableContent_wrapper__J1EXT","is_paragraph":"BreakableContent_is_paragraph__5GvuI"};